import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  root: {},
  _root: {
    ...theme.components.icons.default,
  },
}));

const Warning = ({ classes: injectedClasses }) => {
  const classes = useStyles({ theme: useTheme() });

  return (
    <svg
      className={classNames(injectedClasses.root, classes._root)}
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  );
};

Warning.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

Warning.defaultProps = {
  classes: {},
};

export default Warning;
